import type { ComponentType } from "react";
import {
    Phone, Mail, Monitor, Expand, MapPinned, X, MapPin, Navigation, Download,
    type LucideProps,
} from "lucide-react";
import { IIcon } from "../../interfaces";
import {
    WhatsAppIcon, FacebookIcon, LinkedInIcon, GoogleIcon, type BrandIconProps,
} from "./brandIcons";

// Semantic icon-name -> lucide component. Names kept stable across callers;
// look intentionally close to the previously used Font Awesome icons.
const LUCIDE_MAP: Record<string, ComponentType<LucideProps>> = {
    "phone": Phone,
    "envelope": Mail,
    "desktop": Monitor,
    "expand": Expand,
    "map-location-dot": MapPinned,
    "times": X,
    "location-dot": MapPin,
    "location-arrow": Navigation,
    "download": Download,
};

// Brand names -> inline brand SVG (lucide ships no brand logos).
const BRAND_MAP: Record<string, ComponentType<BrandIconProps>> = {
    "whatsapp": WhatsAppIcon,
    "facebook": FacebookIcon,
    "linkedin": LinkedInIcon,
    "google": GoogleIcon,
};

function Icon({ icon, size = "22px", color }: IIcon) {
    const px = parseInt(size, 10) || 22;
    const resolvedColor = color || "#4A4D4E";

    const Brand = BRAND_MAP[icon];
    if (Brand) {
        return <Brand size={px} color={resolvedColor} />;
    }

    const Lucide = LUCIDE_MAP[icon];
    if (Lucide) {
        return <Lucide size={px} color={resolvedColor} />;
    }

    // Unknown icon: render nothing rather than crash.
    return null;
}

export default Icon;
